import { APIService } from "../../../../../../network/api/APIService";

export const AdminAffiliatePartnersData = (query = {}) => {
    return APIService({
        endpoint: "/affiliate/admin/partners/",
        method: "GET",
        query,
    });
};
